import { Membership, Person } from "../api/person";
import styled, { px, Huge, OverHeading } from "livemap-ui";
import { MainHeader } from "./MainHeader";
import { MembershipCard } from "./MembershipCard";

export interface UserPortalProps {
  user: Person | null;
}

export function UserPortal({ user }: UserPortalProps) {
  if (!user) {
    return null;
  }

  const hasAnyMembership = user.memberships && user.memberships.length;
  const selectOrganization = (membership: Membership) => {
    localStorage.setItem("ORG_ID", membership.organizationId.toString());
    window.location.href = "/manage";
  };

  return (
    <>
      <MainHeader />
      <Intro>
        <Huge>
          {user.firstName} {user.lastName}
        </Huge>
        <OverHeading>
          Joined {new Date(user.registeredAt).toLocaleDateString()}
        </OverHeading>
      </Intro>
      <Memberships>
        {hasAnyMembership
          ? user.memberships?.map((membership) => (
              <MembershipCard
                key={membership.organizationId}
                onClick={() => selectOrganization(membership)}
                membership={membership}
              />
            ))
          : null}
        {!hasAnyMembership ? (
          <NoMemberships>
            <OverHeading>Sorry!</OverHeading>
            <p>You have not yet been invited to an organization.</p>
            <p>Your organizations be displayed here.</p>
          </NoMemberships>
        ) : null}
      </Memberships>
    </>
  );
}

const Intro = styled.div`
  padding: ${px(24, 0)};
  margin-bottom: 12px;
  text-align: center;

  > * {
    text-align: center;
    display: block;
  }
`;

const Memberships = styled.div``;

const NoMemberships = styled.div`
  border-top: 1px solid ${(p) => p.theme.borderColor};
  text-align: center;
  font-size: ${px(14)};
  padding: ${px(24, 0)};

  > * {
    display: block;
  }
`;
